import { useCallback } from 'react';

import * as actions from '../../../store/actions/index';
import useDatosComprobante from './useDatosComprobante';

const crearPdf = (blob, nombreArchivo) => ({
  url: URL.createObjectURL(new Blob([blob], { type: 'application/pdf' })),
  nombreArchivo
});

const liberarPdf = (pdf) => URL.revokeObjectURL(pdf.url);

/**
 * PDF del comprobante como blob URL ({ url, nombreArchivo }), liberado al cambiar de comprobante o desmontar.
 * registrar = false para la vista previa: pedirlo no lo deja como descargado. version: cambiarla lo vuelve a pedir.
 */
const usePdfComprobante = (comprobante, { registrar = true, activo = true, version } = {}) => {
  const cargar = useCallback(
    (comp, success, fail) => actions.loadPdfComprobanteImpresion(comp, success, fail, registrar),
    [registrar]
  );
  const { datos, error, cargando } = useDatosComprobante(comprobante, cargar, { activo, version, alRecibir: crearPdf, alLiberar: liberarPdf });
  return { pdf: datos, error, cargando };
};

export default usePdfComprobante;
